import { PeopleCounterAction } from "./action";
import { PeopleCounterState, initPeopleCounterState } from "./state";

export function PeopleCounterReducer(
  state: PeopleCounterState = initPeopleCounterState,
  action: PeopleCounterAction
): PeopleCounterState {
  switch (action.type) {
    case '@@PeopleCounterState/initBinPeopleCounterListAction':
      return {
        ...state,
        binPeopleCounterList: action.binPeopleCounterList,
      };

    case '@@PeopleCounterState/initTargetBinPeopleCounterAction':
      return {
        ...state,
        targetBinPeopleCounter: action.targetBinPeopleCounter,
      };

    case '@@PeopleCounterState/clearTargetBinPeopleCounterAction':
      return {
        ...state,
        targetBinPeopleCounter: initPeopleCounterState.targetBinPeopleCounter,
      };

    case '@@PeopleCounterState/changeTargetBinPeopleCounterAction':
      return {
        ...state,
        targetBinPeopleCounter: {
          ...state.targetBinPeopleCounter,
          bin_people_counter: action.binPeopleCounter
        }
      };

    default:
      return state;
  }
}
